<template>
  <div>
    <van-sticky v-if="!isTabBar && $route.name !== 'marketV2ShareList'">
      <van-nav-bar left-arrow :title="title" @click-left="onClickLeft" />
    </van-sticky>
    <div class="container">
      <router-view v-slot="{ Component }">
        <keep-alive include="MarketV2AddDaily">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
    <van-tabbar v-model="active" v-if="isTabBar" class="v2-tabbar">
      <van-tabbar-item
        :name="item.routeName"
        v-for="item in navLeft"
        :key="item.routeName"
        :icon="item.icon"
        @click="handleClick(item)"
        >{{ item.name }}</van-tabbar-item
      >
      <van-tabbar-item name="__home" class="tab-home-item" />
      <van-tabbar-item
        :name="item.routeName"
        v-for="item in navRight"
        :key="item.routeName"
        :icon="item.icon"
        @click="handleClick(item)"
        >{{ item.name }}</van-tabbar-item
      >
    </van-tabbar>
    <button
      v-if="isTabBar"
      type="button"
      class="tab-home-fab"
      :class="{ 'is-week': isWeekPage }"
      aria-label="返回首页"
      @click="goHome"
    >
      <van-icon name="wap-home" size="22" />
    </button>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        active: this.$route.name,
        navListAdmin: [
          { name: "看日报", routeName: "marketV2Home", icon: "bookmark-o" },
          { name: "日报统计", routeName: "marketV2StatisticsDaily", icon: "clock-o" },
          { name: "看周报", routeName: "marketV2WeeklyList", icon: "bookmark-o" },
        ],
        navList: [
          { name: "写日报", routeName: "marketV2Home", icon: "shield-o" },
          { name: "看日报", routeName: "marketV2TodayList", icon: "bookmark-o" },
          { name: "写周报", routeName: "marketV2WriteWeekly", icon: "records" },
          { name: "看周报", routeName: "marketV2WeeklyList", icon: "description" },
        ],
      };
    },
    computed: {
      userInfo() {
        return this.$store.state.user.userInfo;
      },
      title() {
        let title = this.$route.query.metaName;
        return title || this.$route.meta.title;
      },
      currentNavList() {
        return this.userInfo.isAdmin ? this.navListAdmin : this.navList;
      },
      navLeft() {
        const list = this.currentNavList;
        return list.slice(0, Math.floor(list.length / 2));
      },
      navRight() {
        const list = this.currentNavList;
        return list.slice(Math.floor(list.length / 2));
      },
      isTabBar() {
        return this.currentNavList.some((item) => item.routeName === this.$route.name);
      },
      isWeekPage() {
        return ["marketV2WriteWeekly", "marketV2WeeklyList"].includes(this.$route.name);
      },
    },
    watch: {
      "$route.name": function (val) {
        this.active = val
      },
    },
    methods: {
      handleClick(item) {
        this.title = item.name;
        this.$router.push({ name: item.routeName});
      },
      goHome() {
        this.active = this.$route.name;
        this.$router.push({ name: "entranceView" });
      },
      onClickLeft() {
        this.$router.back();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .navbar {
    position: fixed;
    top: 0;
    width: 100%;
  }
  .container {
    padding: 0 0 100px 0;
  }
  .v2-tabbar {
    z-index: 200;
    overflow: visible;
  }
  .tab-home-item {
    pointer-events: none;
    :deep(.van-tabbar-item__text),
    :deep(.van-tabbar-item__icon) {
      display: none;
    }
  }
  .tab-home-fab {
    position: fixed;
    left: 50%;
    bottom: 5px;
    z-index: 300;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #07c160;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(-50%);
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.35);
    &.is-week {
      background: #407eff;
      box-shadow: 0 4px 12px rgba(64, 126, 255, 0.35);
    }
  }
</style>
